import React, {useRef, useState} from "react";
import {Button} from 'react-bootstrap'
import {useAlert} from "react-alert";

export default function SimpleUpload({ accept, onUpload, value }) {
  const alert = useAlert();
  const [fileUrl, setFileUrl] = useState(null);
  const inputRef = useRef();

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (evt) => {
      setFileUrl(evt.target.result);
      onUpload(evt.target.result, file);
    };
    // Reset input so the same file can be re-selected if needed
    e.target.value = '';
  }

  function downloadFile() {
    const content = (fileUrl || value).split(',');
    const byteCharacters = atob(content[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const _file = new Blob([byteArray], { type: content[0].replace('data:', '').replace(';base64', '') });
    const fileURL = URL.createObjectURL(_file);
    const popUp = window.open(fileURL);
    if (popUp == null || typeof popUp === 'undefined') {
      alert.show("Desative o seu bloqueador de pop-up para visualizar o relatório!", { type: "error" });
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {/* Input file oculto */}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <Button variant="primary" size="sm" onClick={() => inputRef.current.click()}>
        Upload
      </Button>
      {(fileUrl || value) && (
        <Button variant="success" size="sm" onClick={downloadFile} className="ml-2">
          Download
        </Button>
      )}
    </div>
  );
}
